import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faTrash } from "@fortawesome/free-solid-svg-icons";
import { T } from "react-translator-component";
import { currencyFormat } from "../../functions";

const buttonBaseStyle = {
  minHeight: 48,
  borderRadius: 16,
  border: "none",
  fontWeight: 700,
  boxShadow: "0 16px 30px rgba(15,23,42,0.1)",
};

const MenuCommerceCartBar = ({
  cart,
  currency,
  submitLabel,
  hasCustomizableItems,
  onOpenSummary,
  onResetCart,
  sending = false,
}) => {
  if (!cart?.qty) {
    return null;
  }

  return (
    <div className="menu-commerce-cart-bar">
      <div className="menu-commerce-cart-bar-layout">
        <div>
          <div className="menu-commerce-cart-info-label">
            {T("request.your-request")}
          </div>
          <div className="menu-commerce-cart-info-count">
            {cart.qty} {cart.qty === 1 ? T("request.product") : T("request.products")}
          </div>
          <div className="menu-commerce-cart-info-total">
            {currencyFormat(cart.total, currency)}
          </div>
        </div>

        <div className="menu-commerce-cart-actions">
          <Button
            variant="light"
            onClick={onResetCart}
            disabled={sending}
            style={{
              ...buttonBaseStyle,
              width: 48,
              minWidth: 48,
              padding: 0,
              background: "#F9F2FA",
              color: "#82378A",
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>

          <Button
            className="menu-commerce-cart-primary"
            onClick={onOpenSummary}
            disabled={sending}
            style={{
              ...buttonBaseStyle,
              padding: "0 18px",
              background: "linear-gradient(135deg, #82378A 0%, #A64AAF 100%)",
            }}
          >
            <FontAwesomeIcon icon={faShoppingCart} className="mr-2" />
            {submitLabel || T(hasCustomizableItems ? "request.continue_customize" : "general.continue")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MenuCommerceCartBar;
